export enum LicenseStatus {
    ACTIVE = 'active',
    EXPIRED = 'expired',
    LOCKED = 'locked'
}
